var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6628 5.5999C36.1086 5.5999 36.6003 6.00397 36.6003 6.66045V41.3393C36.6003 41.9958 36.1086 42.3999 35.6628 42.3999H12.7378C12.292 42.3999 11.8003 41.9958 11.8003 41.3393V14.7176L17.8676 14.7176C18.2919 14.7176 18.6989 14.549 18.999 14.249C19.299 13.9489 19.4676 13.5419 19.4676 13.1176V5.5999H35.6628ZM16.6736 3.0615C16.9644 2.66062 17.4366 2.3999 17.9697 2.3999H35.6628C38.017 2.3999 39.8003 4.38115 39.8003 6.66045V41.3393C39.8003 43.6186 38.017 45.5999 35.6628 45.5999H12.7378C10.3836 45.5999 8.60029 43.6186 8.60029 41.3393V13.1176C8.60029 12.737 8.73593 12.3689 8.98286 12.0794L16.6502 3.08839C16.6579 3.07933 16.6657 3.07036 16.6736 3.0615ZM16.2676 8.46862V11.5176L13.6675 11.5176L16.2676 8.46862Z",
    fill: "#EF3F08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0242 21.3804C31.7345 21.9061 31.8841 22.9081 31.3584 23.6184L23.4636 34.285C23.188 34.6575 22.7643 34.8922 22.3023 34.9283C21.8404 34.9644 21.3854 34.7985 21.0552 34.4734L16.4112 29.902C15.7814 29.2821 15.7735 28.2691 16.3934 27.6393C17.0132 27.0096 18.0263 27.0016 18.656 27.6215L21.9873 30.9008L28.7863 21.7146C29.312 21.0044 30.314 20.8547 31.0242 21.3804Z",
    fill: "#EF3F08"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file_check.227c2e2442b3c4023e8c3865accb2341.svg";
export { ForwardRef as ReactComponent };